import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';

import { reinitializeFormData, updateFormData, updateProfileDetails } from '../actions';

import UserInfo2Form from './generic/userInfo2Form';
import { PAGE_ROUTES } from '../../../constants/pageRoutes';
import { checkAuthorization, getQueryRedirectLink, navigateTo, pushError } from '../../global/actions';
import { ROLE_TYPE } from '../../../constants/roles';
import { getUserProfileInfo } from '../../user/actions';
import { MAGIC_NUMBER } from '../../../constants/magicNumbers';

const mapStateToProps = state => ({
  registration: state.Registration,
  global: state.Global,
  dashboard: state.Dashboard,
  user: state.User
});

export const onLoginExpired = (dispatch) => {
  dispatch(pushError('Please login to continue!'));
  setTimeout(() => {
    dispatch(reinitializeFormData());
    dispatch(navigateTo(PAGE_ROUTES.LOGIN));
    return;
  }, MAGIC_NUMBER.QUICK_REDIRECT_DELAY)
}
class OwnerForm3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: null
    };

    this.onNextStep = this.onNextStep.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    const { userId } = this.props.global;

    if (!userId) {
      onLoginExpired(dispatch);
      return;
    }

    dispatch(checkAuthorization());
    dispatch(getUserProfileInfo(userId));
  }

  onNextStep = () => {
    const { userType, dispatch } = this.props;
    const { user } = this.props.user;

    if (!user) {
      onLoginExpired(dispatch);
      return;
    }

    const redirectLink = getQueryRedirectLink();

    if ((userType === ROLE_TYPE.owner && user.accounts && user.accounts.length) ||
      userType === ROLE_TYPE.renter && user.creditCards && user.creditCards.length) {
      dispatch(navigateTo(redirectLink ? redirectLink : PAGE_ROUTES.DASHBOARD));
      return;
    }

    const redirectQuery = redirectLink ? `?redirect=${redirectLink}` : '';

    if (userType === ROLE_TYPE.owner)
      dispatch(navigateTo(PAGE_ROUTES.OWNER_SIGN_UP_2 + redirectQuery));
    else
      dispatch(navigateTo(PAGE_ROUTES.RENTER_SIGN_UP_2 + redirectQuery))
  }

  onSubmit = (values, { setSubmitting }) => {
    const { dispatch, userType } = this.props;
    const { token, userId } = this.props.global;
    const user = this.props.dashboard.user ? this.props.dashboard.user : this.props.user.user;

    if (!userId || !user) {
      onLoginExpired(dispatch);
      return;
    }

    values.code = this.state.code;

    setTimeout(() => {
      dispatch(updateFormData(values));
      dispatch(updateProfileDetails(token, userId, userType, values.profileAbout, values.profilePhoto, values.profileLoyalties))
        .then(data => {
          setTimeout(() => {
            this.onNextStep();
          }, MAGIC_NUMBER.QUICK_REDIRECT_DELAY);
        })
        .finally(() => {
          setSubmitting(false);
        })
    }, 1000);
  }

  onBack = () => {
    let { history } = this.props;
    history.goBack();
  }

  render() {
    return (
      <div className="container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <h1>Update Profile</h1>
        <UserInfo2Form onSubmit={this.onSubmit} onBack={this.onBack} />
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(OwnerForm3));
